import React, { useState, useEffect } from 'react';
import { useNavigate } from "react-router-dom";
import { useAuth } from "../firebase/AuthProvider";
import {
  Typography,
  Box,
  Button,
  Stack,
  Paper,
} from '@mui/material';
import { PostAdd, ListAlt } from '../constants/icons';
import {
  green,
} from '@mui/material/colors';

const getGreeting = () => {
  const hour = new Date().getHours();
  if (hour >= 5 && hour < 11) {
    return 'おはようございます';
  } else if (hour >= 11 && hour < 18) {
    return 'こんにちは';
  } else {
    return 'こんばんは';
  }
};

export default function Home() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [greeting, setGreeting] = useState(getGreeting());

  useEffect(() => {
    // 1分ごとに挨拶を更新チェック
    const timer = setInterval(() => {
      setGreeting(getGreeting());
    }, 60000);

    return () => clearInterval(timer);
  }, []);

  return (
    <>
      <Typography variant="h4" sx={{ textAlign: 'center', my: 2 }}>
        {greeting}
      </Typography>

      <Typography variant="h6" sx={{ textAlign: 'center', my: 6 }}>
        本システムは
        <span style={{ marginInline: '4px', color: green[900] }}>Hozenall Cloud</span>
        のアルファ版であり、<br />
        将来的に各機能を統合集約していく予定です。<br />
      </Typography>

      <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4, px: 2, pb: 3 }}>
        <Paper elevation={3} sx={{ p: 4, maxWidth: 600, width: '100%', borderRadius: 2 }}>
          <Typography variant="h6" gutterBottom sx={{ fontWeight: 'bold', mb: 2, textAlign: 'center' }}>
            案件管理システムの運用開始について
          </Typography>
          <Typography variant="body1" paragraph sx={{ lineHeight: 1.8 }}>
            ＳＦＡ（営業支援システム/機能）の運用を開始しました。<br />
            日々の営業活動や案件情報の登録・更新にご協力ください。<br />
            皆様のデータ入力が、より良い営業戦略につながります。
          </Typography>

          <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} justifyContent="center" sx={{ mt: 4 }}>
            <Button
              variant="contained"
              size="large"
              startIcon={<PostAdd />}
              onClick={() => navigate('/salesprojectscreate')}
              sx={{ px: 4 }}
            >
              新規案件登録
            </Button>
            <Button
              variant="outlined"
              size="large"
              startIcon={<ListAlt />}
              onClick={() => navigate('/salesprojectsmanagement')}
              sx={{ px: 4 }}
            >
              案件リストへ
            </Button>
          </Stack>
        </Paper>
      </Box>
    </>
  );
};
